import axios from "axios";
import { createBrowserHistory } from "history";
import { notification } from "antd";

const history = createBrowserHistory({ forceRefresh: true });

export const urlApi = import.meta.env.VITE_API_URL || "http://localhost:3000";

let API = axios.create({
  baseURL: urlApi,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("assetToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use((response) => {
  const { code, success, message } = response.data;

  if (message) {
    if (success) notification.success({ message });
    else notification.error({ message });
  }

  if (code === "AUTHENTICATION_ERROR") {
    localStorage.setItem("assetToken", "");
    history.push("/login");
  }

  return response;
});

export default API;
